import { colors } from 'config/themes/colors';
import styled, { createGlobalStyle } from 'styled-components';
import { palette } from 'styled-theme';

const AntDatePicker = (ComponentName) => styled(ComponentName)`
  background-color: ${palette('background', 46)};
  color: ${({ theme }) => (theme.name === 'atsFancy' ? palette('foreground', 0) : theme.text.primary)};
  border-color: ${palette('borderColor', 10)};

  &.ant-picker .ant-picker-input > input,
  .ant-picker-separator,
  .ant-picker-suffix {
    color: ${({ theme }) => (theme.name === 'atsFancy' ? palette('foreground', 0) : theme.text.primary)};
  }

  .ant-picker-clear {
    color: ${({ theme }) => (theme.name === 'atsFancy' ? 'rgba(0, 0, 0, 0.25)' : theme.text.primary)};
    background: ${palette('background', 46)};

    &:hover {
      color: ${({ theme }) => (theme.name === 'atsFancy' ? 'rgba(0, 0, 0, 0.45)' : theme.text.primary)};
      background: ${palette('background', 46)};
    }
  }

  &.ant-picker .ant-picker-input > input {
    color: ${({ theme }) => (theme.name === 'atsFancy' ? palette('foreground', 0) : theme.text.primary)};

    &::placeholder {
      color: ${({ theme }) =>
        theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.primary};
    }
  }
  padding: 9px;
  .ant-picker-suffix {
    color: ${({ theme }) => theme.primary};
  }

  &:hover {
    border-color: ${colors.blue[600]};
    background-color: ${palette('background', 46)};
  }

  &.ant-picker-focused,
  &.ant-picker-focused:hover {
    border-color: ${colors.blue[600]};
    background-color: ${palette('background', 46)};
    box-shadow: 0 0 0 3px
      ${({ theme }) => (theme.name === 'atsFancy' ? colors.blue[100] : colors.infoBlueDark[700])};
  }
`;

export const DatePickerGlobalStyles = createGlobalStyle`
  .ant-picker-dropdown .ant-picker-panel-container {
    background: ${({ theme }) => (theme.name == 'atsFancy' ? '#fff' : palette('background', 46))};
  }

  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel {
    background: ${({ theme }) => (theme.name == 'atsFancy' ? '#fff' : palette('background', 46))};
    border-color: ${({ theme }) => (theme.name === 'atsFancy' ? 'rgba(5, 5, 5, 0.06)' : 'rgba(255, 255, 255, 0.15)')};
  }

  .ant-picker-dropdown .ant-picker-header,
  .ant-picker-dropdown .ant-picker-footer {
    border-color: ${({ theme }) => (theme.name === 'atsFancy' ? 'rgba(5, 5, 5, 0.06)' : 'rgba(255, 255, 255, 0.15)')};
  }

  .ant-picker-dropdown .ant-picker-cell {
    color: ${({ theme }) => (theme.name == 'atsFancy' ? colors.gray[200] : colors.gray[500])};
  }

  .ant-picker-dropdown .ant-picker-header button,
  .ant-picker-dropdown .ant-picker-cell-in-view,
  .ant-picker-dropdown .ant-picker-header-view button,
  .ant-picker-dropdown .ant-picker-content th {
    color: ${({ theme }) => (theme.name == 'atsFancy' ? colors.gray[900] : theme.text.primary)};
  }

  .ant-picker-dropdown .ant-picker-cell-in-view .ant-picker-cell-inner {
    color: ${({ theme }) => (theme.name == 'atsFancy' ? colors.gray[900] : theme.text.primary)};
  }

  .ant-picker-dropdown .ant-picker-footer,
  .ant-picker-dropdown .ant-picker-footer a,
  .ant-picker-dropdown .ant-picker-today-btn {
    color: ${({ theme }) => (theme.name == 'atsFancy' ? colors.blue[600] : theme.text.primary)};
  }

  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner {
    &:hover {
      color: #fff;
    }

    &::before {
      border: 1px solid ${({ theme }) => (theme.name === 'atsFancy' ? colors.blue[600] : '#fff')};
    }
  }

  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected:not(.ant-picker-cell-disabled) .ant-picker-cell-inner,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-disabled) .ant-picker-cell-inner,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-disabled) .ant-picker-cell-inner {
    background: ${({ theme }) => (theme.name === 'atsFancy' ? colors.blue[600] : colors.gray[600])};
  }

  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-disabled):before,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range:not(.ant-picker-cell-disabled)::before,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-disabled):not(.ant-picker-cell-range-end-single)::before {
    background: ${({ theme }) => (theme.name === 'atsFancy' ? colors.blue[50] : colors.gray[800])};
  }

  .ant-picker-dropdown .ant-picker-input > input::placeholder {
    color: ${({ theme }) => (theme.name === 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray)};
  }
`;

export default AntDatePicker;
